export default __webpack_public_path__ + "static/media/links-hackathon2018sep.f257982a.png";